<div class="custom-background justify-content-center">
    <div class="text-center">
        <h1 class="title mb-0">Acesso negado!</h1>
        <h2 class="subtitle">Seu acesso não foi concedido.</h2>
    </div>
</div>
